// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"_3cyjJe","subtextClassName":"Hbz6kd"};